import { newToolFilterOAuthMcp } from "../oauth.ts";

export const airopsMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/61fae48cb5979577435753f6/6a564a7c412b525028550f7c_AO-Symbol-Dark.png",
  url: "https://app.airops.com/mcp",
  label: "AirOps",
});
